import { useState } from 'react';
import type { FC } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import DOMPurify from 'dompurify';
import StandardModal, { ModalBody, ModalFooter, ModalSize } from '../Fundamentals/Modal/StandardModal';
import { Checkbox as CheckboxBase } from '../FormComponents/Checkbox';
import useModal from '../../Hooks/useModal';
import routes from '../../Constants/routes';
import type { AnnouncementRelease } from './Announcement.types';
import './ReleaseAnnouncementModal.css';

interface CheckboxProps {
    id: string;
    label: string;
    checked: boolean;
    onChange: (checked: boolean) => void;
}

const Checkbox = CheckboxBase as unknown as FC<CheckboxProps>;

interface ReleaseAnnouncementModalProps {
    announcement: AnnouncementRelease;
    onClose: (remindLater: boolean) => void;
}

const ReleaseAnnouncementModal = ({ announcement, onClose }: ReleaseAnnouncementModalProps) => {
    const { t } = useTranslation();
    const { closeModal } = useModal();
    const [remindLater, setRemindLater] = useState(false);

    const close = () => {
        onClose(remindLater);
        closeModal();
    };

    return (
        <StandardModal title={announcement.title ?? ''} size={ModalSize.LARGE} onClose={() => onClose(remindLater)}>
            <ModalBody>
                {(announcement.summary ?? '') !== '' && (
                    <div className="release-announcement-summary" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(announcement.summary ?? '') }} />
                )}
                <Link to={routes.versionArchiveDetails(announcement.id)} onClick={close}>
                    {t('announcement.readMore')}
                </Link>
            </ModalBody>
            <ModalFooter>
                <div className="w-100 d-flex justify-content-between align-items-center">
                    <Checkbox id="releaseAnnouncementRemindLater" label={t('announcement.remindLater') ?? ''} checked={remindLater} onChange={setRemindLater} />
                    <button type="button" className="btn btn-primary btn-sm" onClick={close}>
                        {t('announcement.close')}
                    </button>
                </div>
            </ModalFooter>
        </StandardModal>
    );
};

export default ReleaseAnnouncementModal;
